/* eslint-disable */
export const citeMorooco = [
  { id: 1, name: "مراكش" },
  { id: 2, name: "مكناس" },
  { id: 3, name: "محاية" },
  { id: 4, name: "عين تاوجطات" },
  { id: 5, name: "سبع عيون" },
  { id: 6, name: "بوفكران" },
  { id: 7, name: "الحاجب" },
  { id: 8, name: "أزرو" },
  { id: 9, name: "إفران" },
  { id: 10, name: "تيزنيت" },
  { id: 11, name: "الرشيدية" },
  { id: 12, name: "تنغير" },
  { id: 13, name: "ميدلت" },
  { id: 14, name: "قلعة مكونة" },
  { id: 15, name: "أكادير" },
  { id: 16, name: "ورزازات" },
  { id: 17, name: "آسفي" },
  { id: 18, name: "الصويرة" },
  { id: 19, name: "بني ملال" },
  { id: 20, name: "الفقيه بن صالح" },
  { id: 21, name: "خريبكة" },
  { id: 22, name: "سطات" },
  { id: 23, name: "الجديدة" },
  { id: 24, name: "الدار البيضاء" },
  { id: 25, name: "المحمدية" },
  { id: 26, name: "الرباط" },
  { id: 27, name: "سلا" },
  { id: 28, name: "تمارة" },
  { id: 29, name: "القنيطرة" },
  { id: 30, name: "سيدي قاسم" },
  { id: 31, name: "سيدي سليمان" },
  { id: 32, name: "طنجة" },
  { id: 33, name: "تطوان" },
  { id: 34, name: "شفشاون" },
  { id: 35, name: "الحسيمة" },
  { id: 36, name: "الناظور" },
  { id: 37, name: "الدريوش" },
  { id: 38, name: "وجدة" },
  { id: 39, name: "بركان" },
  { id: 40, name: "جرادة" },
  { id: 41, name: "تاوريرت" },
  { id: 42, name: "جرسيف" },
];
